import { render, staticRenderFns } from "./statementManager.vue?vue&type=template&id=fb6a1d78&scoped=true&"
import script from "./statementManager.vue?vue&type=script&lang=ts&"
export * from "./statementManager.vue?vue&type=script&lang=ts&"
import style0 from "./statementManager.vue?vue&type=style&index=0&id=fb6a1d78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a1d78",
  null
  
)

export default component.exports